const UPDATE_APP_ID           = 'UPDATE_APP_ID';
const UPDATE_SYSTEM_CONFIGS   = 'UPDATE_SYSTEM_CONFIGS';
const UPDATE_OPTIONS          = 'UPDATE_OPTIONS';
const UPDATE_OPTIONS_BY_CLASS = 'UPDATE_OPTIONS_BY_CLASS';
const CLEAN_OPTIONS           = 'CLEAN_OPTIONS';
const SELECT_FIELD            = 'SELECT_FIELD';
const UPDATE_FILTER_DATE      = 'UPDATE_FILTER_DATE';

export const updateAppID          = (app_id) => ({ type : UPDATE_APP_ID, app_id:app_id })
export const updateSystemConfigs  = (configs) => ({ type: UPDATE_SYSTEM_CONFIGS, configs })
export const updateOptions        = (options) => ({ type : UPDATE_OPTIONS, options:options })
export const updateOptionsByClass = (options_class, options) => ({ type : UPDATE_OPTIONS_BY_CLASS, options_class, options })
export const cleanOptions         = () => ({ type : CLEAN_OPTIONS })
export const selectFieldID        = (id) => ({ type : SELECT_FIELD, id:id }) 
export const updateFilterDate     = (start_date, end_date) => ({ type : UPDATE_FILTER_DATE, start_date:start_date, end_date:end_date  })

const initState = {
  id:null,
  selectedFieldID : null,
  filter_start_date:null,
  filter_end_date:null,
  configs:{},
  options:{},
}

const app = (state = initState, input) => {

  var type = input.type

  if (type === UPDATE_APP_ID)  return { ...state, id:input.app_id };

  if (type === UPDATE_SYSTEM_CONFIGS) return { ...state, configs: input.configs };

  if (type === UPDATE_OPTIONS) return { ...state, options:input.options };
  
  if (type === UPDATE_OPTIONS_BY_CLASS) 
  {
    const {options = {} } = state
    options[input.options_class] = input.options
    return { ...state, options:options };
  }

  if (type === CLEAN_OPTIONS)      {return { ...state, options:{} };  }
  if (type === SELECT_FIELD)       {return { ...state, selectedFieldID:input.id };  }
  if (type === UPDATE_FILTER_DATE) {return { ...state, filter_start_date:input.start_date, filter_end_date:input.end_date };  }
  return state;  
}

export default app


// WEBPACK FOOTER //
// ./src/reducers/app.js